var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-pill",class:_vm.status.toLowerCase()},[_vm._v(" "+_vm._s(_vm.statuses.find((stat) => stat.name === _vm.status).label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }